import { trackEvent } from "../analytics";

const useTrackEvent = () => {
  const trackEventFn = (event: string, properties = {}) =>
    trackEvent(event, properties);

  return trackEventFn;
};

export default useTrackEvent;
